import React, { useCallback, useMemo } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Controller, useForm } from 'react-hook-form';
import clsx from 'clsx';
import VuiSelect from '../../../../../vodea/@vodea-ui/components/Forms/VuiSelect';
import _ from 'lodash';
import { VuiButton } from '../../../../../vodea/@vodea-ui/components/VuiButton';
import { ProductInputs, productUnitItemSchema } from '../../validation';
import { yupResolver } from '@hookform/resolvers/yup';
import UnitRepository from '../../../../../repositories/UnitRepository';
import { useTranslation } from 'react-i18next';
import { IProductData } from '../../index';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  selectedData: Partial<IProductData>;
  customer: any;
  onSubmit: (data: any) => void;
}

const ModalProductItem: React.FC<Props> = ({isOpen, onClose, onSubmit, selectedData, customer}) => {
  const {t} = useTranslation();
  const {
    handleSubmit: cartItemHandleSubmit,
    control: cartItemControl,
    errors: cartItemErrors,
    reset: cartItemReset,
  } = useForm<ProductInputs>({
    resolver: yupResolver(productUnitItemSchema),
    defaultValues: {
      unit_id: null,
    }
  });

  const onItemSubmit = cartItemHandleSubmit((data) => {
    if (onSubmit) {
      const productTiers = selectedData?.product_tiers ?? [];
      const filterProductTiers = productTiers.filter((pt) => pt.unit_id == data?.unit_id?.id);
      const tier = filterProductTiers.find((pt) => 1 >= pt.quantity);
      let price = selectedData.default_price;

      if (tier && (tier?.product_tier_prices ?? []).length) {
        const customerMembershipId = customer?.membership_id;
        // Filter tier prices by customer membership_id
        const tierPrice = tier.product_tier_prices.find((ttp: any) => ttp.membership_id == customerMembershipId);
        price = tierPrice ? Number(tierPrice.price) : Number(tier.product_tier_prices[0].price);
      }

      onSubmit({
        ...selectedData,
        price,
        unit_id: data?.unit_id?.id,
        unit_name: data?.unit_id?.name,
        unit_code: data?.unit_id?.code,
      });
    }
    handleOnClose();
  });

  const handleOnClose = useCallback(() => {
    cartItemReset();
    onClose()
  }, []);


  useMemo(() => {
    if (selectedData && isOpen) {
      cartItemReset({
        unit_id: {
          id: selectedData.unit_id,
          name: selectedData.unit_name,
          code: selectedData.unit_code
        }
      });
    }
  }, [isOpen, selectedData]);

  return (
    <Modal show={isOpen} onHide={handleOnClose} backdrop={'static'} centered>
      <Modal.Header closeButton>
        <Modal.Title>Select Unit</Modal.Title>
      </Modal.Header>

      <form className={'form-wrapper'} onSubmit={onItemSubmit}>
        <Modal.Body>
          <div
            className={clsx({
              'form-group': true,
              error: cartItemErrors.unit_id
            })}
          >
            <label className={'form-label'}>Unit</label>
            <Controller
              name={'unit_id'}
              control={cartItemControl}
              render={props => (
                <VuiSelect
                  propKey={_.get(selectedData, 'id')}
                  selectParams={{
                    for: 'sales-order',
                    product: _.get(selectedData, 'id')
                  }}
                  selectRepository={UnitRepository}
                  defaultValue={props.value}
                  onChange={val => {
                    props.onChange(val);
                  }}
                />
              )}
            />
            <label className={'label-help'}>{_.get(cartItemErrors.unit_id, 'message')}</label>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant={'light'} onClick={onClose}>
            {t('Cancel')}
          </Button>
          <VuiButton forSubmit={true} label={'Save'} loading={false} />
        </Modal.Footer>
      </form>
    </Modal>
  );
}

export default ModalProductItem;